import { Component, OnInit } from "@angular/core";
import { DataService_MultiStationViewVisitors } from "../multi-station-view-visitors/shared/data.service";
import { VisitorLogRequest } from "../multi-station-view-visitors/shared/VisitorLogRequest";
import { Router } from "@angular/router";
import { ReportService } from "../../Report/report.service";
import { LocalstorageService, UserService } from "../../../shared";
import { DialogService } from "primeng/dynamicdialog";
import { ReportFileTypeDialogComponent } from "../../student/shared/report-file-type-dialog/report-file-type-dialog.component";
import * as moment from "moment";

@Component({
	selector: "app-multi-station-view-logs",
	templateUrl: "./multi-station-view-logs.component.html",
	styleUrls: ["./multi-station-view-logs.component.css"],
})
export class MultiStationViewLogsComponent implements OnInit {
	constructor(
		private visitorService: DataService_MultiStationViewVisitors,
		private router: Router,
		private reportService: ReportService,
		private userService: UserService,
		private dialogService: DialogService,
		private localService: LocalstorageService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//
		//	10.15 Try to select a facility based on the last school that was selected
		//
		var lastSchool = this.localService.getItem("SchoolSelector_School");
		if (lastSchool != undefined && lastSchool.SchoolID != undefined) {
			this.LastSchoolID = lastSchool.SchoolID;
		}

		this.DateRangeOption = this.lstDateRangeOption[0];
		this.loadFacility();
		this.loadSemesterStartDate();
	}

	/////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////

	user: any;
	LastSchoolID: number = -1;

	LoadingFacility: boolean = false;
	Facility: any;
	lstFacility: any = [];

	DateRangeOption: any;
	lstDateRangeOption: any = [
		{
			ID: 0,
			Desc: "Today",
		},
		{
			ID: 30,
			Desc: "Last Month",
		},
		{
			ID: 60,
			Desc: "Last 2 Months",
		},
		{
			ID: 90,
			Desc: "Last 3 Months",
		},
		{
			ID: -2,
			Desc: "Current School Year",
		},
		{
			ID: -3,
			Desc: "Custom Range",
		},
		{
			ID: -1,
			Desc: "All",
		},
	];

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	LoadingSemester: boolean = false;
	SemesterStartDate: Date = new Date();

	pagerows: any = 10;
	pagefirst: any = 0;

	LoadingScan: boolean = false;
	lstScan: any = [];
	SelectedVisitorPassDetail: any;
	lstVisitorPassDetailStatusDesc: any = [];
	lstScannedAtLocation: any = [];
	lstVisitorReasonDesc: any = [];
	lstScannedAtFacility: any = [];

	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "LastName", header: "Last Name" },
		{ field: "FirstName", header: "First Name" },
		{ field: "VisitorPassDetailStatusDesc", header: "Status" },
		{ field: "LogDTDesc", header: "Date/Time" },
		{ field: "ScannedAtLocation", header: "Scanned At" },
		{ field: "VisiteeName", header: "Destination" },
		{ field: "VisitorReasonDesc", header: "Reason" },
		{ field: "Notes", header: "Notes" },
		{ field: "ScannedAtFacility", header: "Facility" },
	];

	Processing: boolean = false;

	errorMessage: string = "";

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////

	loadFacility() {
		this.LoadingFacility = true;

		var result = this.visitorService.VisitorFacilitySelectList(this.LastSchoolID);
		result.subscribe(
			(response) => {
				this.lstFacility = response;

				this.lstFacility.unshift({
					FacilityID: -1,
					FacilityName: "All",
				});

				this.Facility = this.lstFacility[0];

				for (var z = 0; z < this.lstFacility.length; z++) {
					var next = this.lstFacility[z];

					if (next.Selected == true) {
						this.Facility = next;
					}
				}

				this.LoadingFacility = false;
			},
			(error) => {
				this.LoadingFacility = false;
			}
		);
	}

	loadVisitor() {
		this.LoadingScan = true;

		if (this.Facility == undefined) {
			this.LoadingScan = false;
			return;
		}
		if (this.DateRangeOption == undefined) {
			this.LoadingScan = false;
			return;
		}

		var fsDate = "";
		var feDate = "";

		if (this.DateRangeOption.ID == -3) {
			fsDate = moment(this.StartDate).format("MM/DD/YYYY");
			feDate = moment(this.EndDate).format("MM/DD/YYYY");
		}

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.LoadingScan = false;
			return;
		}

		var parms: VisitorLogRequest = {
			FacilityID: this.Facility.FacilityID,
			DateRangeOption: this.DateRangeOption.ID,
			StartDate: fsDate,
			EndDate: feDate,
		};

		var result = this.visitorService.VisitorLogSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstScan = response;

				for (var z = 0; z < this.lstScan.length; z++) {
					var next = this.lstScan[z];

					next.RouterLink = "/multistation/viewlog/" + next.VisitorPassDetailID;
				}

				this.lstVisitorPassDetailStatusDesc = Array.from(new Set(this.lstScan.map((item: any) => item.VisitorPassDetailStatusDesc))).sort();
				this.lstScannedAtLocation = Array.from(new Set(this.lstScan.map((item: any) => item.ScannedAtLocation))).sort();
				this.lstVisitorReasonDesc = Array.from(new Set(this.lstScan.map((item: any) => item.VisitorReasonDesc))).sort();
				this.lstScannedAtFacility = Array.from(new Set(this.lstScan.map((item: any) => item.ScannedAtFacility))).sort();

				this.LoadingScan = false;
			},
			(error) => {
				this.LoadingScan = false;
			}
		);
	}

	loadSemesterStartDate() {
		this.LoadingSemester = true;

		var result = this.visitorService.CurrentSemesterStartDateSelect();
		result.subscribe(
			(response: any) => {
				this.SemesterStartDate = response.InfoDT;

				this.LoadingSemester = false;
			},
			(error) => {
				this.LoadingSemester = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////

	onSearch() {
		this.loadVisitor();
	}

	onPrint() {
		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.onFinishPrint(response);
			}
		});
	}

	onFinishPrint(OutputTypeID) {
		var component = this;
		this.errorMessage = "";

		var strParam = this.GetStrParam();
		this.Processing = true;

		var reportID = 447;

		var result = this.reportService.Print(reportID, strParam, 0, OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.Processing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.Processing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		///////////////////////////////////////////
		// Start Date
		///////////////////////////////////////////

		//Today
		if (this.DateRangeOption.ID == 0) {
			this.StartDate = new Date();
		}
		//Last Month
		else if (this.DateRangeOption.ID > 0) {
			this.StartDate = new Date();
			this.StartDate.setDate(this.StartDate.getDate() - this.DateRangeOption.ID);
		}
		//Current Semester
		else if (this.DateRangeOption.ID == -2) {
			this.StartDate = this.SemesterStartDate;
		}
		//All
		else if (this.DateRangeOption.ID == -1) {
			this.StartDate = new Date("1970-01-01");
		}

		var fsDate: string = moment(this.StartDate).format("MM/DD/YYYY");
		///////////////////////////////////////////

		///////////////////////////////////////////
		// Filters
		///////////////////////////////////////////

		var visitorTypeID = "-1";
		var visitorStatusID = "-1";
		var visitorPassDetailStatusID = "-1";

		///////////////////////////////////////////

		//Parameter 1: SchoolID
		strParam += 0 + "|SchoolID";

		//Parameter 2: FacilityID
		strParam += "," + this.Facility.FacilityID + "|FacilityID";

		//Parameter 3: StartDate
		strParam += "," + fsDate + "|StartDate";

		//Parameter 4: EndDate
		strParam += "," + moment(this.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 5: VisitorTypeID
		strParam += "," + visitorTypeID + "|VisitorTypeID";

		//Parameter 6: VisitorStatusID
		strParam += "," + visitorStatusID + "|VisitorStatusID";

		//Parameter 7: VisitorPassDetailStatusID
		strParam += "," + visitorPassDetailStatusID + "|VisitorPassDetailStatusID";

		//Parameter 8: SortBy
		strParam += "," + "Date" + "|SortBy";

		//Parameter 9: SortDirection
		strParam += "," + "Descending" + "|SortDirection";

		//Parameter 10: UserID
		strParam += "," + this.user.userID + "|UserID";

		//Parameter 11: ImageLogo
		strParam += "," + "" + "|Imagelogo";

		return strParam;
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////////

	onRowSelect(val) {
		this.SelectedVisitorPassDetail = val.data;
	}
	onRowUnselect(val) {
		this.SelectedVisitorPassDetail = null;
	}
	onRowDblClick(VisitorPassDetail) {
		this.SelectedVisitorPassDetail = VisitorPassDetail;

		document.getElementById("Link" + VisitorPassDetail.VisitorPassDetailID).click();
	}

	/////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingFacility == true || this.LoadingScan == true || this.LoadingSemester == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////////////////////
}
